import { z } from 'zod';

export const CodeEnforcementActionScalarFieldEnumSchema = z.enum(['actionId','cityId','caseId','actionType','dateAction','timeAction','details','letterId','actionBy','department','weather','material','photoTaken','numHours','externalId','rowTimestamp']);

export default CodeEnforcementActionScalarFieldEnumSchema;
